import React, { Component } from 'react';
import Header from './Header';
import PostImage from './PostImage';
import Footer from './Footer';

class Post extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLiked: false,
      likeAnimation: { scale: [0, 0, 0] },
      animationFlipper: true,
    };
  }

  handleLike() {
    this.setState({
      isLiked: !this.state.isLiked,
    });
  }

  handleDblClick() {
    this.setState({
      isLiked: true,
      likeAnimation: { scale: [0, 1.3, 1, 1, 0] },
      animationFlipper: !this.state.animationFlipper,
    });
  }

  render() {
    const { author, thumbnail, hoursOld } = this.props.postData;
    const { image } = this.props;
    const { username } = this.props;
    const { text } = this.props;
    let isLiked = this.state.isLiked;
    let likeAnimation = this.state.likeAnimation;
    let animationFlipper = this.state.animationFlipper;
    return (
      <div className="post">
        <Header author={author} thumbnail={thumbnail} />
        <PostImage
          image={image}
          onDblClick={() => this.handleDblClick()}
          likeAnimation={likeAnimation}
          animationFlipper={animationFlipper}
        />
        <Footer
          author={author}
          text={text}
          hoursOld={hoursOld}
          username={username}
          isLiked={isLiked}
          onLike={() => this.handleLike()}
        />
      </div>
    );
  }
}
export default Post;
